import InputType from "common/form/InputType";
import ButtonSelect from "common/form/widgets/common/ButtonSelect";
import { Form, Input } from "decorator-form";

const viewsInput = ButtonSelect.registerWithOptions([
	{value: 'alertMessage', label: 'Alert Message'},
	{value: 'alertHeading', label: 'Alert Heading'},
	{value: null, label: "None"}
]);

@Form({title: "Alert Panel Config"})
export default class AlertPanelConfig {

	// @Input({type: InputType.CHECKBOX, title: "Wrap in Block View"})
	// Depricated, keep and check to avoid updating configs
	//public useBlockView?: boolean;

	@Input({type: InputType.TEXTAREA, title: "Alert Message"})
    public alertBody: string;
    
    @Input({type: InputType.TEXT, title: "Alert Title"})
    public alertTitle: string;

	public labelKey: string;
}



// WEBPACK FOOTER //
// ./src/panels/alert/AlertPanelConfig.ts